import React, {useState} from 'react';
import './InfoTooltip.css';

const InfoTooltip = ({text}) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div className="info-tooltip-wrapper">
            <span
                className="info-tooltip-icon"
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                onClick={() => setIsVisible(!isVisible)}
            >
                ❓
            </span>
            {isVisible && (
                <div className="info-tooltip-popup">
                    {text}
                </div>
            )}
        </div>
    );
};

export default InfoTooltip;
